import EditorImg from 'lowcode/components/EditorImg';
import { FC, useState } from 'react';
import BottomSubscribe from '../BottomSubscribe';
import styled from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';

interface IProps {
    type?: string;
}

const EU_SITES = ['es', 'it', 'eu', 'uk', 'de', 'fr'];

const Banner: FC<IProps> = ({}) => {
    const { t } = useLang('membersday.teaser.ActivityPreview');
    const { locale } = getLocal();

    const [list, setList] = useState([
        {
            value: '1',
            checked: false,
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711103911205/Flash%20Sale-eventjpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711103999669/Flash%20Sale-eventjpg.jpg',
            title: '',
            text: t('itema'),
            textColor: t('itema1'),
        },
        {
            value: '2,3',
            checked: false,
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711006583865/Best%20Sellersjpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711006561500/2jpg.jpg',
            title: t('itemb0'),
            text: t('itemb2'),
            textColor: t('itemb1'),
        },
        {
            value: '4',
            checked: false,
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711006473020/Accessoryjpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711103324650/3jpg.jpg',
            title: '',
            text: t('itemc'),
            textColor: t('itemc1'),
        },
    ]);

    const handleChecked = (index: number) => {
        if (!EU_SITES.includes(locale)) return;
        const newList = [...list];
        newList[index].checked = !newList[index].checked;
        setList(newList);
    };

    const handleSuccess = () => {
        const newList = [...list];
        newList.map((item) => (item.checked = false));
        setList(newList);
    };

    return (
        <>
            <div className={`${styled.Banner} teaser-ActivityPreview`} id="teaser-ActivityPreview">
                <div className="members-day-inter">
                    <div className="members-day-title">
                        {t.rich('title', {
                            text: (text: string) => <span className="members-day-endtitle">{text}</span>,
                        })}
                    </div>
                    <div className="box-items">
                        {list.map((item, index) => (
                            <div key={item.value} className={`box-item ${item.checked && 'checked'}`} onClick={() => handleChecked(index)}>
                                <EditorImg pc={item.pc} h5={item.h5} />
                                {item.title && <p className="img-text">{item.title}</p>}
                                <div className="box-msg">
                                    {item.textColor ? (
                                        <>
                                            <span className={`box-msg-color2 ${['fr'].includes(locale) ? 'default-color' : ''}`}>{item.textColor}</span>
                                            <p>{item.text}</p>
                                        </>
                                    ) : (
                                        item.text
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            {EU_SITES.includes(locale) && <BottomSubscribe list={list} success={handleSuccess} />}
        </>
    );
};

export default Banner;
